import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

import { BaseService, } from '@smartsoftware/reflex-core';
import { HttpClient, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Auth } from '../../auth';
import {
    UserModel, UserService,
    CustomerUserModel, CustomerUserService
} from '../../resource-module';


@Injectable()
/**
 * Service where data inputed in the various onboarding steps is collected
 * prior to the registration being completed.
 */
export class RegistrationService extends BaseService {

    protected servicePath : string = '/';

    /**
     * Object where user input from onboarding is stored.
     */
    public userRegistration: {
        email?: string,
        phone?: string,
        mobilePhone?: string,
        fullName?: string,
        country?: string,
        postalCode?: string,
        channels?: string[],
        city?: string,
        [key: string]: any
    } = {};

    constructor(
        protected _router: Router,
        protected _http: HttpClient,
        protected _userService: UserService,
        protected _customerUserService: CustomerUserService,
        protected _auth: Auth) {
        super(_http);
    }

    public checkAvailability(aliasType: string, aliasValue: string): Observable<any> {
        return this.http.post(
            this.apiUrl + '/Auth/signupCheck',
            {
                name: aliasType,
                value: aliasValue
            },
            {
                observe: 'response'
            }
        ).pipe(
            map(
                (response: HttpResponse<any>) => response.body
            )
        ).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Make request to Auth/user/signUp endpoint to create cognito user.
     */
    public signUp(userProps: CreateUserEventBody): Observable<any> {
        return this.http.post(
            this.apiUrl + '/Auth/signUp',
            userProps,
            {
                observe: 'response'
            }
        ).pipe(
            map(
                (response: HttpResponse<any>) => response.body
            )
        ).pipe(
            catchError(this.handleError)
        );
    }

    public verifyAccount(username: string, code: string) {
        return this.http.post(
            this.apiUrl + '/Auth/confirmSignUp',
            {
                username: username,
                confirmationCode: code
            },
            {
                observe: 'response'
            }
        ).pipe(
            map(
                (response: HttpResponse<any>) => response.body
            )
        ).pipe(
            catchError(this.handleError)
        );
    }

    public authenticate(credentials:any) {
        return this.http.post(
            this.apiUrl + '/Auth/login',
            credentials,
            {
                observe: 'response'
            }
        ).pipe(
            map(
                (response: HttpResponse<any>) => response.body
            )
        ).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Complete new password challenge request when prompted during the
     * password creation step.
     */
    public respondToAuthChallenge(username: string, newPassword: string) {
        return this.http.post(
            this.apiUrl + '/Auth/challenge',
            {
                challengeName: 'NEW_PASSWORD_REQUIRED',
                challengeResponses: {
                    'USERNAME': username,
                    'NEW_PASSWORD': newPassword
                },
                session: this.userRegistration['session']
            },
            {
                observe: 'response'
            }
        ).pipe(
            map(
                (response: HttpResponse<any>) => response.body
            )
        ).pipe(
            catchError(this.handleError)
        );
    }

    /**
     * Create user profile in 'Users' table. Update cognito user attributes
     * with first and last name from 'fullname'.
     */
    public finalizeRegistration() {

        let firstName = this.userRegistration.firstName;
        let lastName = this.userRegistration.lastName;
        let userModel: UserModel = new UserModel();

        userModel.email = this.userRegistration.email || '';
        userModel.name = firstName + ' ' + lastName;
        userModel.address = this.userRegistration.address1 + (this.userRegistration.address2 ? ('\n' + this.userRegistration.address2) : '') + '\n'
                            + this.userRegistration.city + ', ' + this.userRegistration.state + ' ' + this.userRegistration.zip;
        userModel.phone = this.userRegistration.phone;
        userModel.mobilePhone = this.userRegistration.mobilePhone;
        userModel.cognitoId = this.userRegistration.username;
        userModel.company = this.userRegistration.company;
        // Back end will fill out actual permissions
        userModel.role = {
            id: this.userRegistration.r,
            name: '',
            isAdmin: false,
            isCustomer: false,
            isSuperAdmin: false,
            isDriver: false,
            isMechanic: false,
            isGuest: false,
            isAccounter: false,
            isSalesRep: false
        }

        userModel.customer = null;/*{
            profile: {
                name: firstName + ' ' + lastName,
                addressStreet: '',
                addressCity: '',
                addressState: '',
                addressZip: '',
                fax: '',
                contact: []
            },
            billing: {
                name: firstName + ' ' + lastName,
                addressStreet: '',
                addressCity: '',
                addressState: '',
                addressZip: '',
                fax: '',
                contact: []
            },
            taxProfile: {
                id: '',
                code: ''
            }
        };*/

        // For CustomerUsers
        userModel.customerId = this.userRegistration.customerId;

        this._userService.push(userModel).subscribe((response) => {
            console.log('onboarding response: ', response);
//            this._auth.credentials = this._auth.credentials; // TODO force auth changed event to update ui.
            //this._router.navigate(['/']);
            if (this.userRegistration.customerId != null) {

                let customerUserModel: CustomerUserModel = new CustomerUserModel({
                    customerId: this.userRegistration.customerId,
                    userId: response.uuid.toString()
                });

                this._customerUserService.push(customerUserModel).subscribe((customerUserResponse: any) => {})
            }

        });

        this._userService.welcomeUser(userModel.email).subscribe((response) => {
            console.log('welcome sent: ', response);
        });
    }
}

export interface CreateUserEventBody {
    username?: string;
    email?: string;
    password? :string;
    phone_number? : string;
    given_name? : string;
    family_name? : string;
    email_verified?: string;
    phone_number_verified?: string;
}
